import React from 'react'

const PaymentLoader = () => {
    return (
        <div className='pls-loader-wrap'>
            <svg viewBox="0 0 240 240" height="240" width="240" className="pls-loader">
                <circle stroke-linecap="round" stroke-dashoffset="-330" stroke-dasharray="0 660" stroke-width="20" stroke="#000" fill="none" r="105" cy="120" cx="120" className="pls-loader-ring pls-loader-ring-a"></circle>
                <circle stroke-linecap="round" stroke-dashoffset="-110" stroke-dasharray="0 220" stroke-width="20" stroke="#000" fill="none" r="35" cy="120" cx="120" className="pls-loader-ring pls-loader-ring-b"></circle>
                <circle stroke-linecap="round" stroke-dasharray="0 440" stroke-width="20" stroke="#000" fill="none" r="70" cy="120" cx="85" className="pls-loader-ring pls-loader-ring-c"></circle>
                <circle stroke-linecap="round" stroke-dasharray="0 440" stroke-width="20" stroke="#000" fill="none" r="70" cy="120" cx="155" className="pls-loader-ring pls-loader-ring-d"></circle>
            </svg>
            {/* <div className='pls-txt'>Please Wait! We are verifying you payment.</div> */}
            <div className='pls-txt'>Please Wait!</div>
        </div>
        )
}

export default PaymentLoader